var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandGrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8884 5.88887C14.8884 5.99962 14.8822 6.10891 14.8701 6.21642L18.1011 13.2671L18.7454 12.9992C19.2364 12.7951 19.7999 13.0277 20.004 13.5187L21.852 17.9646C22.2602 18.9468 21.7951 20.074 20.8131 20.4823L19.924 20.852C18.942 21.2603 17.815 20.795 17.4067 19.8129L15.5588 15.367C15.3547 14.8759 15.5872 14.3123 16.0782 14.1081L16.7667 13.8219L14.0595 7.91439C13.5355 8.44728 12.8063 8.77773 12 8.77773C11.1937 8.77773 10.4645 8.44728 9.9405 7.91439L7.2333 13.8219L7.92177 14.1081C8.41278 14.3123 8.64535 14.8759 8.44123 15.367L6.59327 19.8129C6.18503 20.795 5.05801 21.2603 4.07599 20.852L3.18694 20.4823C2.20493 20.074 1.73979 18.9468 2.14803 17.9646L3.99599 13.5187C4.20011 13.0277 4.76362 12.7951 5.25463 12.9992L5.89887 13.2671L9.12993 6.21642C9.1178 6.10891 9.11157 5.99962 9.11157 5.88887C9.11157 4.29339 10.4048 3 12 3C13.5952 3 14.8884 4.29339 14.8884 5.88887Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandGrip);
export default __webpack_public_path__ + "static/media/hand-grip.a23e112e6aca520d3b37e814a2cfa891.svg";
export { ForwardRef as ReactComponent };